export const EUR = (v, decimals = 2) => {
  if (v == null || isNaN(v)) return "€0.00";
  const sign = v < 0 ? "-" : "";
  return `${sign}€${Math.abs(v).toLocaleString("it-IT", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })}`;
};

export const EURc = (v) => {
  const s = v > 0 ? "+" : "";
  return `${s}${EUR(v)}`;
};

export const pct = (v, d = 1) => `${v > 0 ? "+" : ""}${(v ?? 0).toFixed(d)}%`;

export const num = (v, d = 2) => (v ?? 0).toLocaleString("it-IT", {
  minimumFractionDigits: d, maximumFractionDigits: d,
});

export const pnlColor = (v) => (v > 0 ? "text-profit" : v < 0 ? "text-loss" : "text-zinc-400");

export const fmtTime = (iso) => {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("it-IT", {
    timeZone: "Europe/Rome", day: "2-digit", month: "2-digit",
    hour: "2-digit", minute: "2-digit",
  });
};

export const fmtClock = (iso) => {
  if (!iso) return "—";
  return new Date(iso).toLocaleTimeString("it-IT", {
    timeZone: "Europe/Rome", hour: "2-digit", minute: "2-digit", second: "2-digit",
  });
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("it-IT", {
    timeZone: "Europe/Rome", day: "2-digit", month: "2-digit", year: "numeric",
  });
};

export const dur = (sec) => {
  if (!sec) return "—";
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  if (h > 0) return `${h}h ${m}m`;
  return `${m}m`;
};
